/**
 * Bundle / config permissions → PermissionContext 계약
 * { [categoryKo: string]: string[] }
 */
export function extractPermissionsFromBundle(bundle) {
  if (!bundle || typeof bundle !== 'object') {
    return {};
  }

  let raw =
    bundle.permissions ??
    bundle.permission ??
    null;

  // 가끔 { data: { ... } } / { pages: { ... } } 래핑
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    const keys = Object.keys(raw);
    const looksLikePageMap = keys.some((k) => Array.isArray(raw[k]));
    if (!looksLikePageMap) {
      if (raw.pages && typeof raw.pages === 'object') {
        raw = raw.pages;
      } else if (raw.permissions && typeof raw.permissions === 'object') {
        raw = raw.permissions;
      } else if (raw.data && typeof raw.data === 'object') {
        raw = raw.data;
      }
    }
  }

  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return {};
  }

  const normalized = {};
  for (const [category, value] of Object.entries(raw)) {
    if (Array.isArray(value)) {
      normalized[category] = value.map(String);
    } else if (value && typeof value === 'object') {
      // { '오더 입력': true } 또는 { pages: [...] }
      if (Array.isArray(value.pages)) {
        normalized[category] = value.pages.map(String);
      } else {
        normalized[category] = Object.keys(value).filter((page) => {
          const v = value[page];
          return v === true || v === 1 || v === '1' || v === 'Y';
        });
      }
    } else if (typeof value === 'string') {
      normalized[category] = value.split(',').map((s) => s.trim()).filter(Boolean);
    }
  }

  return normalized;
}

export function hasPermissionEntries(permissions) {
  return Boolean(
    permissions &&
      typeof permissions === 'object' &&
      !Array.isArray(permissions) &&
      Object.keys(permissions).length > 0
  );
}

/** Bundle 분배 완료 시 PermissionContext 등이 구독 */
export const BUNDLE_DISTRIBUTED_EVENT = 'bundleDistributed';
